module.exports = __webpack_public_path__ + "img/scene2.87ed61bd.webp";